<script lang="ts" setup>
import { content } from '#tailwind-config';

definePageMeta({
  layout: 'home',
})

const news = [
  {
    time: '2025.03.25',
    title: '【FaW TOKYOご招待】仕入れコスト削減＆小ロット生産を現場でご案内！',
    imgs: ['https://static-jp.theckb.com/static-asset/xr/new4.png'],
    id: '1',
    contents: `
平素よりTHECKBをご愛顧いただき、誠にありがとうございます。

この度、弊社THE CKB（直行便）は、3月26日（水）～28日（金）に東京ビッグサイトで開催する「FaW TOKYO（ファッションワールド東京）春」に出展することとなりました！

当日はオンラインでは見つからない卸仕入れ商品や、コスト削減につながる仕入れ先の提案を行うほか、小ロット生産可能なOEM工場と直接相談機会も提供いたします。

仕入れ先・OEM工場の開拓に絶好の機会ですので、ぜひ展示会にお越しください。

【展示会概要】  
・開催日程： 2025年3月26日(水)～28日(金)   10:00～17:00
・会場: 東京ビッグサイト 〒135-0063 東京都江東区有明3-11-1
・ブース番号：４F南ホール3出入口 S23-18

※本展は事前の来場登録が必要です！ ご登録は以下のURLからお願いします 。
▶ 来場ご登録はこちらから！ 
<a href='https://www.fashion-tokyo.jp/spring/ja-jp/register.html?code=1303009669436604-DXU'>https://www.fashion-tokyo.jp/spring/ja-jp/register.html?code=1303009669436604-DXU</a>

【ご来場者限定オファー】
展示会にご来場いただいたお客様には、限定特典として無料サンプルをお送りし、さらに特別割引をご提供します！

皆様のご来場を心よりお待ちしております！
何卒、よろしくお願い申し上げます。
    `
  },
  {
    time: '2024.5.27',
    title: 'CEO呉氏、早稲田大学にて中国・日本間の越境EC市場を分析',
    imgs: ['https://static-s.theckb.com/sniffGroup/imgs/202405270062/0.png', 'https://static-s.theckb.com/sniffGroup/imgs/202405270062/1.png', 'https://static-s.theckb.com/sniffGroup/imgs/202405270062/2.png'],
    contents: `
杭州CKBのCEOである呉氏は、日本の名門大学である早稲田大学より正式に招待を受け、日中間の経済・文化交流を促進するための学術講演を行った。

早稲田大学にて開催された**「日中貿易イノベーションフォーラム」** において、呉CEOは中国・日本間の越境EC市場の最新動向、直面する課題、そして今後のビジネスチャンスについて、詳細な分析を発表した。特に、越境ECにおける市場環境の変化、規制対応、そして今後の成長戦略 についての考察は、業界関係者から高い関心を集めた。

本フォーラムには、学生や大学関係者、EC業界の専門家が参加 し、呉CEOの講演はその明確かつ実践的な内容から、聴衆より高く評価された。杭州CKBは今後も、中国・日本間の貿易促進と越境EC市場の発展に向けて貢献していく。
    `,
    id: '2'
  },
  {
    time: '2023.11.23',
    title: 'THE CKB × 1688 世界初の協力イベント開催',
    imgs: ['https://static-s.theckb.com/sniffGroup/imgs/202311230052/0.png', 'https://static-s.theckb.com/sniffGroup/imgs/202311230052/1.png', 'https://static-s.theckb.com/sniffGroup/imgs/202311230052/2.png', 'https://static-s.theckb.com/sniffGroup/imgs/202311230052/3.png'],
    contents: `
2023年11月15日、CKBグループの呉リーダー率いる日本訪問チーム が、日本・品川プリンスホテルに到着。その後、THE CKBと中国最大のB2B卸売プラットフォーム「1688」 は正式に提携し、これを機に戦略セミナー を開催した:

本セミナーでは、以下の主要テーマについて議論が行われた:
・THE CKBが1688のサービスを活用し、調達コストを削減する方法
・1688の公式選定工場と顧客との連携体制
・OEM開発戦略
・ブランド競争力を向上させる手法

THE CKBと1688の協力は、企業の成功を支援するとともに、「中国輸入完成品OEM革命」を推進する強力なパートナーシップとなる。

今後の展望
THE CKBは、AIや最新技術の活用、サプライチェーンの最適化 を通じて、市場調査から納品までのワンストップサービス を提供していく。さらに、品質とサービスレベルの向上 に努め、より高い満足度を実現するために尽力していく。
    `,
    id: '3'
  },
  {
    time: '2023.10.11',
    title: 'SNIFF Group子会社「イト二フ」、盛大に開業',
    imgs: ['https://static-s.theckb.com/sniffGroup/imgs/202310110048/0.png', 'https://static-s.theckb.com/sniffGroup/imgs/202310110048/1.png', 'https://static-s.theckb.com/sniffGroup/imgs/202310110048/2.png', 'https://static-s.theckb.com/sniffGroup/imgs/202310110048/3.png'],
    contents: `
SNIFF Groupの子会社 「イト二フ（Zhejiang Ito Nifu Supply Chain Co., Ltd.）」 が、2023年9月9日に正式に開業した。

「イト二フ」 は、SNIFF Groupと伊藤忠グループの合弁会社であり、伊藤忠は長い歴史を持つ日本の大手投資会社で、Fortune Global 500 に継続的にランクインしている（伊藤忠公式サイト）。

今回の伊藤忠との戦略的提携により、WEGO や ADASTRIA などの大手クライアントの獲得が期待されるだけでなく、海外のオフライン市場への展開が加速する。これにより、中国のEC商品が FamilyMart や しまむら などの実店舗を通じて日本の消費者に直接届くことが可能となる。

また、日本市場にとどまらず、韓国向けシステムは8月17日に正式リリース され、英語版システムも10月に公開予定 である。

今後、SNIFF Groupは国際展開をさらに強化し、より多くの消費者に高品質な製品とサービスを提供していく。

伊藤忠（中国）グループの東アジア事業
伊藤忠（中国）グループは、1972年に中国政府から日中友好貿易会社として認定されて以来、40年以上にわたり中国市場で事業を展開 している。東アジア地域本部は、華北・華東・華南・台湾・韓国の5拠点 に加え、長春・ウランバートルの2つの支社 を有する。東アジア全域で700名以上の従業員 を擁し、伊藤忠の海外事業の中核を担っている。
    `,
    id: '4'
  }
]

const id = useRoute().params.news
const newInfo = computed(() => {
  return news.find(item => item.id === id)
})

const crubs = computed(() => {
  return [{ label: 'ニュース', link: '/news' }, { label: newInfo.value?.title ?? '' }]
})
</script>

<template>
  <div>
    <XrHeader />
    <XrCrumb :list="crubs" />
    <ADevice>
      <template #h5>
        <div class="px-[12px] py-[32px] text-black/85">
          <div class="text-[24px] leading-[32px] ">{{ newInfo?.title }}</div>
          <div class="mt-[8px] text-[12px] leading-[20px]">
            <span class="mr-[16px]">{{ newInfo?.time }}</span> イベント
          </div>
          <div class="mt-[16px]">
            <ElImage class="w-full mb-[16px]" v-for="img in newInfo?.imgs" :src="img" :key="img" alt="" />
          </div>
          <pre class="whitespace-pre-wrap text-[16px] leading-[24px]" v-html="newInfo?.contents"></pre>
        </div>
      </template>
      <template #pc>
        <div class="text-black/85 w-[1120px] mx-auto">
          <div class="font-black text-[48px] leading-[56px]">ニュース</div>
          <div class="flex mt-[48px] justify-between items-start">
            <div class="text-[14px] leading-[24px] pr-[120px]">
              <div>イベント</div>
              <div class="mt-[8px]">{{ newInfo?.time }}</div>
            </div>
            <div class="flex-1 text-[32px] leading-[40px]">{{ newInfo?.title }}</div>
          </div>
          <div class="mt-[48px]">
            <ElImage class="w-full mb-[32px]" v-for="img in newInfo?.imgs" :src="img" :key="img" alt="" />
          </div>
          <div class="w-[764px] mx-auto pb-[48px]">
            <pre class="whitespace-pre-wrap text-[16px] leading-[24px]" v-html="newInfo?.contents"></pre>
          </div>
        </div>
      </template>
    </ADevice>
    <XrFooter />
  </div>
</template>

<style lang="less" scoped></style>
